import React__default, { useState, useEffect, Children } from 'react';
import SwiperCore, { Navigation, Pagination, Autoplay, Virtual } from 'swiper';
import { renderPaginationStyle, renderSwipeButton } from './helper.es.js';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);
const Slider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual = true
  } = _b, swiperProps = __objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual"
  ]);
  const {
    slidesPerView,
    slidesPerGroup,
    slidesPerColumn,
    pagination,
    autoplay,
    loop
  } = swiperProps;
  const [swiperKey, setSwiperKey] = useState(0);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (!slidesPerGroup)
    swiperProps.slidesPerGroup = slidesPerView;
  useEffect(() => {
    setSwiperKey((key) => key + 1);
  }, [autoplay, loop, speed, pauseOnMouseEnter, virtual, slidesPerColumn]);
  return /* @__PURE__ */ React__default.createElement(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows,
    paginationColor
  }, /* @__PURE__ */ React__default.createElement(Swiper, __spreadProps(__spreadValues({
    key: `swiper-${swiperKey}`
  }, swiperProps), {
    slidesPerColumnFill: "row",
    resizeObserver: true,
    virtual: virtual ? {
      addSlidesBefore: slidesPerView
    } : false
  }), Children.map(children, (child, index) => /* @__PURE__ */ React__default.createElement(SwiperSlide, {
    key: index,
    virtualIndex: index
  }, child))));
};
const Wrapper = styled.div(({
  isMultipleRows,
  paginationStyle,
  paginationColor,
  navigationStyle,
  theme
}) => `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${renderPaginationStyle(paginationStyle, theme, paginationColor)};
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    ${renderSwipeButton(navigationStyle)};
`);

export { Slider };
